app.controller('popupTakenDrugUpdateController', ['$scope', '$state', '$mdDialog', 'objectHelper', 'baseModel',
            'applicationModel', 'visitModel', 'userModel', 'patientModel', 'prescribedDrugModel', 'takenDrugToUpdate',
            'preview',
    function ($scope, $state, $mdDialog, objectHelper, baseModel, applicationModel, visitModel, userModel,
              patientModel, prescribedDrugModel, takenDrugToUpdate, preview) {

        function setData() {
            $scope.forms = {
                takenDrugForm: null
            };

            $scope.takenDrug = angular.copy(takenDrugToUpdate);
            if(!$scope.takenDrug.patient) {
                $scope.takenDrug.patient = new PatientVO();
                $scope.takenDrug.patient.id = $state.params.patientId;
            }

            $scope.takenDrugActionType = 'update';
            $scope.presentDate = new Date();

            $scope.vm = {
                p2Drug: new P2DrugVO()
            };

            if($scope.takenDrug.drug) {
                $scope.vm.p2Drug.name = $scope.takenDrug.drug.name;
                $scope.vm.p2Drug.form = $scope.takenDrug.drug.form;
                $scope.vm.p2Drug.strength = $scope.takenDrug.drug.strength;

                $scope.packagesOptions = [$scope.takenDrug.drug.packing];
            }

            $scope.previewOnly = preview || ($scope.takenDrug.author.userType === 'DOCTOR' && $scope.takenDrug.author.id != userModel.currentUser.id);
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$watch('vm.p2Drug', function (newVal) {
                if(newVal) {
                    // if p2Drug hasn't got any packages it means that it is created initially and we don't need to create new takenDrug object
                    if(newVal.packages) {
                        $scope.takenDrug.drug = new DrugVO();
                        $scope.takenDrug.drug.name = newVal.name;
                        $scope.takenDrug.drug.commonName = newVal.commonName;
                        $scope.takenDrug.drug.form = newVal.form;
                        $scope.takenDrug.drug.strength = newVal.strength;

                        $scope.packagesOptions = newVal.packages.map(function (p) {
                            return p.drugPackage;
                        });
                    }
                } else {
                    $scope.takenDrug.drug = null;
                    $scope.packagesOptions = null;
                }
            });

        }

        function setActions() {
            $scope.takenDrugAction = function () {

                $scope.forms.takenDrugForm.$setSubmitted();
                if ($scope.forms.takenDrugForm.$valid) {
                    $scope.actionInProgress = true;

                    prescribedDrugModel.update($scope.takenDrug).then(function() {
                        $scope.actionInProgress = false;
                        $mdDialog.hide();
                    });
                }
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            }
        }

        function configureInterface() {

        }

        function initialize() {
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
